import { useState, useEffect } from 'react';

export interface GeolocationCoords {
  latitude: number;
  longitude: number;
}

interface GeolocationState {
  coords: GeolocationCoords | null;
  loading: boolean;
  denied: boolean;
  error: string | null;
}

const SAO_PAULO_COORDS: GeolocationCoords = {
  latitude: -23.550520,
  longitude: -46.633308,
};

export function useGeolocation(): GeolocationState & { defaultCoords: GeolocationCoords } {
  const [state, setState] = useState<GeolocationState>({
    coords: null,
    loading: true,
    denied: false,
    error: null,
  });

  useEffect(() => {
    if (!navigator.geolocation) {
      setState({ coords: null, loading: false, denied: true, error: 'Geolocalização não suportada' });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setState({
          coords: {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          },
          loading: false,
          denied: false,
          error: null,
        });
      },
      (err) => {
        const denied = err.code === err.PERMISSION_DENIED;
        setState({
          coords: null,
          loading: false,
          denied,
          error: err.message,
        });
      },
      { timeout: 10000, maximumAge: 60000 }
    );
  }, []);

  return { ...state, defaultCoords: SAO_PAULO_COORDS };
}
